export const EMAILJS_CONFIG = {
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_9co8t0a",
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_j0ym5kv",
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "lh3YhDooVD8ZdlJzF",
};
